import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatDate } from '../../../utils/buyerInsightsDates';
import { eventDotColor } from '../../../utils/buyerInsightsFormat';

// "What happened" (spec §3): dated plain-language list, newest first. The phone rendering of the
// timeline; shown under the lanes on desktop.
const TimelineEvents = ({ events }) => (
  <Box>
    <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
      What happened
    </Typography>
    {!events || events.length === 0 ? (
      <Typography variant="caption" color="text.secondary">
        Nothing happened in this period.
      </Typography>
    ) : (
      <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
        {events.map((e, i) => (
          <Box
            component="li"
            key={`${e.day}-${e.kind}-${e.size_label || ''}-${i}`}
            sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.5, borderTop: i ? '1px solid' : 'none', borderColor: 'divider' }}
          >
            <Typography variant="caption" color="text.secondary" sx={{ width: 48, flexShrink: 0, pt: '2px', whiteSpace: 'nowrap' }}>
              {formatDate(e.day)}
            </Typography>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: eventDotColor(e.kind), flexShrink: 0, mt: '7px' }} />
            <Typography variant="body2">{e.text}</Typography>
          </Box>
        ))}
      </Box>
    )}
  </Box>
);

export default TimelineEvents;
